import axios from 'axios'
import { baseApiUrl } from '../config/config'

export const sendGooglePaymentToken = async (params) => {
  // console.log(params)
  try {
    const res = await axios.post(`${baseApiUrl}/pay-with-google`, params)
    // console.log(res.data)
    return res.data
  } catch (err) {
    throw new Error(err.name)
    // return null
  }
}
